import { Toaster } from "@/components/ui/sonner";
import { ThemeProvider } from "@/shared/providers/theme-provider";
import { TrpcProvider } from "@/shared/providers/trpc-provider";
import { Outlet, createRootRoute } from "@tanstack/react-router";

export const Route = createRootRoute({
  component: RootLayout,
});

function RootLayout() {
  return (
    <TrpcProvider>
      <ThemeProvider>
        <a
          href="#main-content"
          className="sr-only focus:not-sr-only focus:absolute focus:left-4 focus:top-4 focus:z-50 focus:rounded-md focus:border focus:border-border focus:bg-card focus:px-4 focus:py-2 focus:text-sm focus:font-medium focus:text-foreground focus:shadow-lg"
          data-testid="app-skip-to-main"
        >
          Přeskočit na hlavní obsah
        </a>
        <Outlet />
        <Toaster richColors closeButton />
      </ThemeProvider>
    </TrpcProvider>
  );
}
